import React, { Component } from 'react';
import EditorShell from '../editor/index.js';
import DebuggerShell from '../debugger/index.js';
import PlaygroundShell from '../playground/index.js';

export default class WorkflowsShell extends Component {
  render() {
    const section = this.props.match.params.section || "editor";
    return (
      <>
        <div className={( "editor" === section ) ? "" : "hidden"}>
          <EditorShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            shown={"editor" === section}
          />
        </div>
        <div className={( "debugger" === section ) ? "" : "hidden"}>
          <DebuggerShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
          />
        </div>
        <div className={( "playground" === section ) ? "" : "hidden"}>
          <PlaygroundShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            shown={"playground" === section}
          />
        </div>
      </>
    );
  }
}
